/**
 * 小程序不入栈跳转
 * @param url
 */
export const redirectTo = url => {
  wx.miniProgram.redirectTo({
    url
  });
};
/**
 * 小程序入栈跳转
 * @param url
 */
export const navigateTo = url => {
  wx.miniProgram.navigateTo({
    url
  });
};
/**
 * 小程序tab bar跳转, 并关闭其他非tab bar页面
 * @param url
 */
export const switchTab = url => {
  wx.miniProgram.switchTab({
    url
  });
};
/**
 * 设置微信小程序分享信息:
 * 1.目标页将会在webview中打开,仅需传目标页(H5)链接
 * 2.分享链接将会自动去除token
 * @param data: {
 * 	title: string; 分享title
 *	link: string; 分享链接
 *	imgUrl: string; 分享图片
 * }
 */
export const setShareInfo = data => {
  const {
    title,
    link,
    imageUrl
  } = data || {};
  // 剔除链接内用户登录态相关参数
  const safeUrl = url => url.replace(/&(token)=[^&]+/gi, "");
  wx.miniProgram.postMessage({
    data: {
      type: "share",
      data: data ? {
        title,
        imageUrl,
        path: `/pages/webview/index?url=${encodeURIComponent(safeUrl(link))}`
      } : null
    }
  });
};